<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo" @click="ToHome">
          <img src="@/assets/img/caixun_logo3.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0 && item.children.length<3">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
          <dl v-if="item.name=='产品中心'" class="more-product">
            <dt v-for="(i,n) in item.children" :key="n">
              <strong>{{i.name}}</strong>
              <div class="right-pro">
                <span v-for="(j,ind) in i.grandson" :key="ind">
                  <router-link :to="j.path">{{j.name}}</router-link>
                </span>
              </div>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <div class="header-nav-logo">
          <img src="@/assets/img/caixun_logo.png">
        </div>
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick" >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu">
            <router-link :to="item.path"> 
              {{item.name}}
              <i class="udnerline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Ceiling",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-hamburger",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "产品中心",
          path: "/ProductCenter",
          children: [
            {
              name: "数据采集产品",
              path:"",
              grandson:[
                {
                  name:"库采仪",
                  path:"/ProductDetail/0/0"
                },
                {
                  name:"快采仪",
                  path:"/ProductDetail/0/1"
                },
                {
                  name:"到件狂扫",
                  path:"/ProductDetail/0/2"
                },
                {
                  name:"多面扫",
                  path:"/ProductDetail/0/3"
                },
              ]
            },
            {
              name: "智能集成产品",
              path:"",
              grandson:[
                {
                  name:"快手",
                  path:"/ProductDetail/1/0"
                },
                {
                  name:"皮带秤",
                  path:"/ProductDetail/1/1"
                },
                {
                  name:"皮带秤三合一",
                  path:"/ProductDetail/1/2"
                },
                {
                  name:"快手三合一",
                  path:"/ProductDetail/1/3"
                },
                {
                  name:"动态三合一",
                  path:"/ProductDetail/1/4"
                },
                {
                  name:"静态三合一",
                  path:"/ProductDetail/1/5"
                },
                {
                  name:"动态包裹秤",
                  path:"/ProductDetail/1/6"
                },
              ]
            },
            {
              name: "自动控制产品",
              path:"",
              grandson:[
                {
                  name:"一分四",
                  path:"/ProductDetail/2/0"
                },
                {
                  name:"Z型小车智能分拣机",
                  path:"/ProductDetail/2/1"
                },
                {
                  name:"摆轮",
                  path:"/ProductDetail/2/2"
                },
                {
                  name:"伸缩机",
                  path:"/ProductDetail/2/3"
                },
              ]
            },
            {
              name: "手持穿戴产品",
              path:"",
              grandson:[
                {
                  name:"巴枪PDA",
                  path:"/ProductDetail/3/0"
                },
                {
                  name:"手持穿戴采集器",
                  path:"/ProductDetail/3/1"
                }
              ]
            },
            {
              name: "其他",
              path:"",
              grandson:[
                {
                  name:"无人缴费终端",
                  path:"/ProductDetail/4/0"
                },
                {
                  name:"智能柔性工作台",
                  path:"/ProductDetail/4/1"
                }
              ]
            },
          ]
        },
        {
          name: "解决方案",
          path: "/answer",
          children: []
        },
        {
          name: "客户案例",
          path: "/CustomesExample",
          children: []
        },
        { 
          name: "招贤纳士",
          path: "/JoinUs",
          children: []
        },
        // {
        //   name: "视频教程",
        //   path: "/VideoTutorial",
        //   children: []
        // },
        // {
        //   name: "关于采寻",
        //   path: "/AboutUs",
        //   children: [
        //     {
        //       name:"公司简介",
        //       path:"/AboutUs"
        //     },
        //     {
        //       name:"联系我们",
        //       path:"/ContactUs"
        //     }
        //   ]
        // }
        {
          name: "联系我们",
          path: "/ContactUs",
          children: []
        }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    ToHome(){
      this.$router.push({name:"home"})
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-remove") {
        this.menuClass = "glyphicon glyphicon-menu-hamburger";
      } else {
        this.menuClass = "glyphicon glyphicon-remove";
      }
    },
  }
};
</script>
<style lang="less" scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
  opacity: 0.6;
  position: absolute;
  z-index: 999;
  width: 100%;
  /* 导航栏 */
  .header-nav{
    height: 100px;
    /* 导航栏logo */
    .header-nav-logo {
      cursor: pointer;
      transition: all ease 0.6s;
      width: 33px;
      height: 22px;
      float: left;
      margin-top: 10px;
    }
    .header-nav-wrapper{
      line-height: 100px;
      float: right;
      margin: 0;
      max-width: 800px;
      >li{
        float: left;
        margin: 0 20px;
        position: relative;
        >a{
          color: #000;
          font-size: 15px;
          font-weight: bold;
          padding: 10px 0;
          position: relative;
          >i{
            display: block;
            position: absolute;
            bottom: -2px;
            left: 50%;
            width: 0;
            height: 2px;
            opacity: 0;
            transition: all 0.6s ease;
            background-color: #0350C2;
          }
          /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
          >span{
            font-size: 12px;
            transition: transform ease 0.5s;
          }
        }
        >a:hover{
          color: #0350C2;
          text-decoration: none;
          /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
          .underline{
            opacity: 1;
            width: 100%;
            left: 0;
          }
          /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
          span{
            transform: rotate(180deg);
          }
          dl{
            display: block;
          }
        }
        
        /* 导航栏 每个导航下面的二级导航容器 */
        >dl{
          display: none;
          position: absolute;
          // width: 128px;
          top: 100%;
          left: -30%;
          z-index: 999999;
          padding:  0 20px;
          box-shadow: 0 0 3px 1px #ccc;
          background: #fff;
          transition: all ease 1s;
          dt{
            float: left;
            color: #212121;
            width: 100%;
            padding: 10px 0;
            text-align: center;
            a{
              padding-bottom: 3px;
            }
            a:hover{
              border-bottom: 1px solid #0350C2;
              color: #0350C2;
              cursor: pointer;
              text-decoration: none;
            }
            a:focus{
              outline: none;
              color: #0350C2;
              text-decoration: none;
            }
          }
        }
        >dl.more-product{
          width: 920%;
          padding: 10px;
          text-align: left;
          left: -150%;
          dt{
            display: inline-block;
            padding-left: 20px;
            width: 20%;
            border-bottom: none;
            strong{
              font-size: 15px;
              width: 100%;
              display: inline-block;
              padding-bottom: 10px;
              text-align: left;
            }
            strong:hover{
              color: #0350C2;
              cursor: default;
              text-decoration: none;
            }
            .right-pro{
              display: flex;
              flex-direction: column;
              flex-wrap: wrap;
              text-align: left;
              
              span{
                font-size: 14px;
                line-height: 30px;
                cursor: pointer;
                color: #000000;
              }
            }
          }
        }
      }
      /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
      li.active > a {
        color: #0350C2;
        text-decoration: none;
        border-bottom: 2px solid #0350C2;
      }
      /* 导航栏 滑上一级导航显示二级导航 */
      li:hover dl{
        display: block;
      }
    }
  }
}
#header:hover{
  opacity: 1;
  // .header-nav .header-nav-logo{
  //   // background: url(../assets/img/logo2.png) no-repeat;
  // }
}
 
@media screen and (max-width: 997px) {
  #header{
    opacity: 1;
    position: relative;
    .header-nav-m{
      .header-nav-m-logo{
        height: 50px;
        position: relative;
        img{
          width: 95px;
          height: 45px;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
      }
      /* 导航栏  菜单容器 */
      .header-nav-m-menu{
        color: #fff;
        height: 50px;
        font-size: 20px;
        line-height: 50px;
        background: rgba(0, 0, 0, 0.7);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        // border-bottom: 1px solid #797979;
        .header-nav-logo{
          // width: 38px;
          // height: 22px;
          img{
            height: 40px;
          }
          // background: url(../assets/img/caixun_logo.png) no-repeat;
          // background: url(../assets/img/mobile_icon.png) -0 -220px no-repeat;
        }
        /* 导航栏 菜单图标 */
        .header-nav-m-menu-wrapper{
          position: absolute;
          top: 43%;
          right: 20px;
          margin-top: -20px;
          width: 50px;
          height: 40px;
          color: #fff;
          z-index: 999999;
          font-size: 12px;
        }
        /* 导航栏 */
        .header-nav-m-wrapper{
          position: absolute;
          top: 50px;
          left: 0;
          width: 100%;
          background: #474747;
          z-index: 9999999;
          li{
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #272727;
            a{
              color: #fff;
              font-size: 14px;
              font-weight: bold;
              padding: 15px 0;
              position: relative;
              span{
                font-size: 10px;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 996px){
  #header{
    
    .header-nav{

       /* 导航栏 */
      .header-nav-wrapper{
       
        >li{
          >a{
            font-size: 14px;
            
          }
        }
      }
    }
  }
}
</style>
